import gql from "graphql-tag";

export default gql`
  query Kpis($tickerSymbol: String!, $language: ISO6391LanguageCode) {
    kpis(tickerSymbol: $tickerSymbol, language: $language) {
      currency
      reportDates {
        annual
        quarterly
        isTrailingTwelveMonths
      }
      annual {
        ...KeyPerformanceIndicatorFields
      }
      quarterly {
        ...KeyPerformanceIndicatorFields
      }
    }
  }

  fragment KeyPerformanceIndicatorFields on KeyPerformanceIndicator {
    kpi
    name
    description
    format
    isDiscontinued
    isImportant
    isCurrency
    series
  }
`;
